

document.addEventListener("DOMContentLoaded", function() {

  // Función para aplicar estilos solo en pantallas de hasta 750px
  function applyStylesIfMobile() {
    if (window.innerWidth <= 750) {
      // Crear un observer para monitorear cambios en el DOM general
      const observer = new MutationObserver(() => {
        const components = document.querySelectorAll('spark-product-card');
        components.forEach((component, index) => {
          if (component.shadowRoot) {

            // Encuentra todos los elementos <select> dentro del shadow root y aplica los estilos
            const selectElements = component.shadowRoot.querySelectorAll('select');
            selectElements.forEach((select, selectIndex) => {
              select.style.minWidth = "0";
              select.style.setProperty("min-width", "0", "important");
              select.style.width = "75%";
              select.style.setProperty("width", "75%", "important");
              console.log(`Estilos aplicados al <select> en posición ${selectIndex} dentro del componente ${index}: min-width eliminado, width establecido al 75%`);
            });

            // Encuentra el botón con la clase .btn-small dentro del shadow root y aplica el estilo
            /* const button = component.shadowRoot.querySelector('.btn-small');
            if (button) {
              button.style.width = "83%";
              button.style.setProperty("width", "83%", "important");
            } */
          }
        });
      });

      // Configuración del observer para observar hijos dentro del DOM general
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Llama a la función inicialmente y también al redimensionar la ventana
  applyStylesIfMobile();
  window.addEventListener("resize", applyStylesIfMobile);
});
